import { ALTERNATIVE_FIELD_IDS, COMPLEX_DATA_CONNECTION_FIELDS } from './constants';
import { DataSourceStatus } from './enums/data-source-status';
import { FieldGroup, getFieldGroupOfFieldId } from './location-utils';
import { LSCField } from '../../models/LSCFields';

/**
 * Determine whether a given field (column) should show a data source connection (green bubble)
 * Relevant for location list
 */
export const isFieldWithDataSource = (fieldId: LSCField | string): boolean => {
  const fieldsWithoutDs = [
    LSCField.status,
    LSCField.businessStatus,
    ALTERNATIVE_FIELD_IDS['businessStatus'],
    'latLng', // validated coordinates in diff popup
    LSCField.comment,
    LSCField.differences,
    LSCField.gxSpecialHours,
    LSCField.coordinate,
  ];

  return !(getFieldGroupOfFieldId(fieldId) === FieldGroup.GMB_SPECIFIC ||
      getFieldGroupOfFieldId(fieldId) === FieldGroup.BLS_SPECIFIC ||
      fieldsWithoutDs.includes(fieldId));
};

/**
 * Differences component can show complex fields which data connection status depends on data
 * connection status of several subfields
 * Determines whether fieldId is such a field
 * @param fieldId
 */
export const isComplexDataConnectionField = (fieldId: string): boolean => {
  return Object.keys(COMPLEX_DATA_CONNECTION_FIELDS).includes(fieldId);
};

/**
 * Data connection-related HTML helper
 * @param dataSourceIconType
 */
export const getDataSourceIconTooltipKey = (dataSourceIconType: Lowercase<DataSourceStatus>): string => {
  return `ADDRESS_LIST.DATA_SOURCE_CONFIG.TOOLTIP.${dataSourceIconType?.toUpperCase()}`;
};

/**
 * Data connection-related HTML helper
 * @param dataSourceIconType
 */
export const getDataSourceIconName = (dataSourceIconType: Lowercase<DataSourceStatus>): string => {
  return dataSourceIconType ===
  DataSourceStatus.PARTIALLY_ACTIVE.toLowerCase() ? 'partial_connection' :
      DataSourceStatus.ACTIVE.toLowerCase() ? 'fiber_manual_record' :
          'fiber_manual_record_outline';
};